import React from "react";
import { palet, FlexColumn, Spacer, FlexRow } from "../../ui";
import SpendeskLogo from "../../images/spendesk-logo.svg";

export const Layout = ({
  children,
  onAdminClick,
  currentView,
  showAdminButton,
}) => {
  return (
    <FlexColumn className="bg-gray-50 min-h-screen">
      <div
        style={{
          background: palet.spendeskColor.darkPuple,
        }}
        className="h-[50px] text-center text-white fixed right-0 left-0 flex justify-center items-center z-10"
      >
        <img src={SpendeskLogo} className="h-10" alt="" />

        {/* Admin Button */}
        {showAdminButton && (
          <div className="absolute right-4 flex items-center h-full">
            <button
              onClick={onAdminClick}
              className={`px-3 py-1.5 text-sm font-medium rounded-md border-none cursor-pointer transition-all duration-200 leading-normal
              ${
                currentView === "admin"
                  ? "bg-white text-purple-900"
                  : "bg-white/15 text-white hover:bg-white/25"
              }`}
            >
              Admin
            </button>
          </div>
        )}
      </div>
      <Spacer size="large" />

      <FlexRow>
        <div className="mx-auto flex-1">{children}</div>
      </FlexRow>
    </FlexColumn>
  );
};
